import { Navigate, useRoutes } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

// layouts
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
import Page404 from './pages/Page404';
import DashboardAppPage from './pages/DashboardAppPage';
import SignUpForm from './DevelopmentComp/Others/SignUpForm';
import LoginPage from './DevelopmentComp/Others/LoginPage';
import CourierOrderCreation from './DevelopmentComp/Transactions/Booking/CourierOrderCreation';
import SalesFollowupPanel from './DevelopmentComp/Transactions/Sales/SalesFollowupPanel';
import ManageBooking from './DevelopmentComp/Transactions/Booking/ManageBooking';
import CustomerComplaintReview from  './DevelopmentComp/Transactions/Booking/CustomerComplaintReview';
import OrderApproval from './DevelopmentComp/Transactions/Admin/OrderApproval';
import CargoOrderCreation from './DevelopmentComp/Transactions/Booking/CargoOrderCreation';
import LedgerApproval from './DevelopmentComp/Transactions/Admin/LedgerApproval';
import ManagePickUp from './DevelopmentComp/Transactions/Common/ManagePickUp';
import CargoRate from './DevelopmentComp/Masters/CargoRate';
import OrderFollwUps from './DevelopmentComp/Transactions/Sales/OrderFollwUps';
import PreBooking from './DevelopmentComp/Transactions/Sales/PreBooking';
import SignUpCRM from './DevelopmentComp/Transactions/CRM/SignUpCRM';
import LedgerFollowupTracker from './DevelopmentComp/Reports/LedgerFollowupTracker';
import OrderFollowupTracker from './DevelopmentComp/Reports/OrderFollowupTracker';
import ComplaintReview from './DevelopmentComp/Reports/ComplaintReview';
import ComplaintMailLog from './DevelopmentComp/Reports/ComplaintMailLog';
import UserSignature from './DevelopmentComp/Others/UserSignature';
import GetQuotation from './DevelopmentComp/Others/GetQuotation';

// ----------------------------------------------------------------------

const isAuthenticated = () => {
  const token = sessionStorage.getItem('authToken');
  return token;
};

// const isAuthenticated = () => {
//   const token = sessionStorage.getItem('authToken');
//   return true;
// };

const hasAccess = (screenName) => 
  // const access = sessionStorage.getItem(`${screenName}`) === 'Y';
   true
;

// ProtectedRoute HOC
const ProtectedRoute = ({ element, screenName }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  if (!hasAccess(screenName)) {
    return <Page404 />;
  }
  return element;
};

// for  techvel dashboard
export default function Router() {
  const routes = useRoutes([
    {
      path: '/dashboard',
      element: (
        <>
          <Helmet>
            <title>Teeparam | Dashboard</title>
          </Helmet>
          <DashboardLayout />
        </>
      ),

      children: [
        // { index: true, element: <DashboardAppPage />, shortname: 'Dashboard' },
        { path: 'home', element: <DashboardAppPage />, shortname: 'Dashboard' },
        // transactions route
        { path: 'manage/ledger_approval', element: <LedgerApproval />, shortname: 'LedgerApproval' },
        { path: 'manage/sales/ledger_followups', element: <SalesFollowupPanel />, shortname: 'SalesFollowupPanel' },
        { path: 'manage/sales/order_followups', element: <OrderFollwUps />, shortname: 'OrderFollwUps' },
        { path: 'manage/pre_booking', element: <PreBooking />, shortname: 'PreBooking' },
        { path: 'manage/sales/pre_booking', element: <PreBooking />, shortname: 'PreBooking' },
        { path: 'manage/courier_order_creation/:ShipType', element: <CourierOrderCreation />, shortname: 'CourierOrderCreation' },
        { path: 'manage/manage_pick_up', element: <ManagePickUp />, shortname: 'ManagePickUp' },
        { path: 'manage/courier_order_creation/:Type/:EditId/:Status', element: <CourierOrderCreation />, shortname: 'CourierOrderCreation' },
        { path: 'manage/cargo_order_creation/:ShipType', element: <CargoOrderCreation />, shortname: 'CargoOrderCreation' },
        { path: 'manage/cargo_order_creation/:Type/:EditId/:Status', element: <CargoOrderCreation />, shortname: 'CargoOrderCreation' },
        { path: 'manage/order_approval', element: <OrderApproval />, shortname: 'OrderApproval' },
        { path: 'manage/booking', element: <ManageBooking />, shortname: 'ManageBooking' },
        { path: 'manage/customer_complaint_review', element: <CustomerComplaintReview />, shortname: 'CustomerComplaintReview' },
        { path: 'manage/signup_crm', element: <SignUpCRM />, shortname: 'SignupCRM' },
        { path: 'master/cargo_rate', element: <CargoRate />, shortname: 'CargoRate' },
        { path: 'manage/LedgerFollowupTracker', element: <LedgerFollowupTracker />, shortname: 'LedgerFollowupTracker' },
        { path: 'manage/OrderFollowupTracker', element: <OrderFollowupTracker />, shortname: 'OrderFollowupTracker' },
        { path: 'manage/ComplaintReview', element: <ComplaintReview />, shortname: 'ComplaintReview' },
        { path: 'manage/ComplaintMailLog', element: <ComplaintMailLog />, shortname: 'ComplaintMailLog' },

      ].map((route) => ({
        ...route,
        element: <ProtectedRoute element={route.element} screenName={route.shortname} />,
      })),
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="login" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ].map((route) => ({ ...route, element: <ProtectedRoute element={route.element} /> })),
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
    {
      path: 'login',
      element: (
        <>
          <Helmet>
            <title>Teeparam | Login</title>
          </Helmet>
          <LoginPage />
        </>
      ),
    },
    {
      path: 'signup',
      element: (
        <>
          <Helmet>
            <title>Teeparam | Sign Up</title>
          </Helmet>
          <SignUpForm />
        </>
      ),
    },
    {
      path: 'signature/:db/:id',
      element: (
        <>
          <Helmet>
            <title>Teeparam | Signature</title>
          </Helmet>
          <UserSignature />
        </>
      ),
    },
    {
      path: 'getquotation',
      element: (
        <>
          <Helmet>
            <title>Teeparam | Quotation</title>
          </Helmet>
          <GetQuotation/>
        </>
      ),
    },
  ]);

  return routes;
}
